import React, { useState, useEffect } from 'react';
import { Button, Modal, Progress, message, Tooltip, Space } from 'antd';
import { Form, InputGroup, Badge, Table } from 'react-bootstrap';
import {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
    EyeOutlined,
    WhatsAppOutlined,
    ShareAltOutlined,
    LoginOutlined,
    UploadOutlined,
    CompassOutlined
} from '@ant-design/icons';
import { Select, DatePicker, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import { formatUrlString, encryptId, getuserdata, loginapi } from '../../services/apiService';
import axios from 'axios';
import { oneKlicks, sendWhatsApp } from '../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import ImageShow from '../../Uitiles/ImageShow';
import decodeHtml from '../../Uitiles/decodeHtml';
import { debugLog } from '../../utils/debug';
import Paginationnew from '../../Uitiles/Paginationnew';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import AddInvoiceModel from './Components/AddInvoiceModel';
import FetchBloodBankMapModal from './Components/FetchBloodBankMapModal';
import { useJsApiLoader } from '@react-google-maps/api';

import { read, utils } from 'xlsx';

const { TextArea } = Input;

const BloodBanks = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [usertype, setUsertype] = useState('');
    const [showPackageModal, setShowPackageModal] = useState(false);
    const [selectedBloodBankForPackage, setSelectedBloodBankForPackage] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const [totalPages, setTotalPages] = useState(0);

    const [callStatusOptions] = useState([
        { value: 'Reschedule', label: 'Reschedule' },
        { value: 'Not Respond', label: 'Not Respond' },
        { value: 'Wrong Number', label: 'Wrong Number' },
        { value: 'Not Interested', label: 'Not Interested' },
        { value: 'Not Answered', label: 'Not Answered' },
    ]);
    const [callStatusValue, setCallStatusValue] = useState(null);
    const [callStatusModelshow, setCallStatusModelshow] = useState(false);
    const [selectedBloodBankForCallStatus, setSelectedBloodBankForCallStatus] = useState(null);
    const [callRemarks, setCallRemarks] = useState('');

    useEffect(() => {
        getBloodBanks();
    }, [searchText, page]);

    const getBloodBanks = async () => {
        try {
            setLoading(true);
            const tableSchema = '';
            const tableName = 'blood_bank';
            const conditions = {
                // status: '1' 
            };
            const orderBy = 'id DESC';
            const search = {
                ...searchText && {
                    display_name: searchText,
                    phone: searchText,
                    id: searchText
                }
            };

            const pagination = {
                page: page,
                limit: limit
            };
            const margedata = [
                {
                    target_table: "user_package",
                    target_column: "user_id",
                    target_value: "id",
                    target_label: "user_package",
                    margedata: [
                        {
                            target_table: "packages",
                            target_column: "id",
                            target_value: "package_id",
                            target_label: "package_details"
                        }
                    ]
                },
            ];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            if (!response || !response.data) {
                // throw new Error('Invalid response from server'); // Commented out to prevent crash on empty response
            }

            setData(response.data);
            setTotalPages(response.totalPages);
            setUsertype(await getuserdata('user_type'));
        } catch (error) {
            console.error('getBloodBanks error:', error);
            message.error('Failed to fetch blood banks');
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleLoginAs = async (record) => {
        const persintuser = await getuserdata('full');
        localStorage.setItem('presentuser', JSON.stringify(persintuser));
        localStorage.setItem('redirect_url_admin', '/superadmin/blood-banks');

        if (!record.email || record.email === "") {
            const randomNumber = Math.floor(1000 + Math.random() * 9000);
            const createemail = `${record.display_name.replace(/\s+/g, '').toLowerCase()}${Date.now()}${randomNumber}@meddylist.com`;
            await oneKlicks.update('', 'blood_bank', { email: createemail }, { id: record.id });
            record.email = createemail;
        }

        const loginResponse = await loginapi(record.email, record.pass, true);
        const user = loginResponse.data[0];

        if (user) {
            if (user.status === "2") {
                toast.error("Account deleted");
                return;
            }
            const userData = {
                id: user.id,
                email: user.email,
                user_type: user.user_type,
                display_name: user.display_name || user.email
            };
            const loginSuccess = await login(userData);
            if (loginSuccess) {
                toast.success("Logged in as Blood Bank user");
                navigate("/blood-bank/dashboard");
            }
        }
    };

    const [editModalVisible, setEditModalVisible] = useState(false);
    const [editingBloodBank, setEditingBloodBank] = useState(null);
    const [editFormData, setEditFormData] = useState({});
    const [uploading, setUploading] = useState(false);

    const handleEdit = (record) => {
        setEditingBloodBank(record);
        setEditFormData({ ...record });
        setEditModalVisible(true);
    };

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: ['places']
    });

    const geocodeAddress = async (address) => {
        if (!isLoaded || !window.google) {
            console.error("Google Maps API not loaded");
            return { lat: null, lng: null, photo: null };
        }

        return new Promise((resolve) => {
            const geocoder = new window.google.maps.Geocoder();

            geocoder.geocode({ address: address }, (results, status) => {
                if (status === 'OK' && results && results.length > 0) {
                    const location = results[0].geometry.location;
                    const lat = location.lat();
                    const lng = location.lng();

                    // Resolve basic coordinates immediately if photo service is not needed
                    // or try to fetch photo
                    const service = new window.google.maps.places.PlacesService(document.createElement('div'));
                    const request = {
                        location: location,
                        radius: '100',
                        query: address
                    };

                    service.textSearch(request, (placeResults, placeStatus) => {
                        let photoUrl = null;
                        if (placeStatus === window.google.maps.places.PlacesServiceStatus.OK && placeResults && placeResults[0]) {
                            const place = placeResults[0];
                            if (place.photos && place.photos.length > 0) {
                                photoUrl = place.photos[0].getUrl({ maxWidth: 800, maxHeight: 600 });
                            }
                        }
                        // Always resolve with whatever coordinates we got
                        resolve({ lat: lat.toString(), lng: lng.toString(), photo: photoUrl });
                    });
                } else {
                    console.warn(`Geocode failed for ${address}: ${status}`);
                    resolve({ lat: null, lng: null, photo: null });
                }
            });

            // Timeout safety
            setTimeout(() => resolve({ lat: null, lng: null, photo: null }), 5000);
        });
    };

    const handleEditSave = async () => {
        try {
            setLoading(true);

            let lat = editFormData.lat;
            let lng = editFormData.lng;
            let profile_photo_url = editFormData.profile_photo_url;

            // If address changed or lat/lng missing, re-geocode
            if (editFormData.address !== editingBloodBank.address || !lat || !lng) {
                const enriched = await geocodeAddress(editFormData.address);
                if (enriched.lat) {
                    lat = enriched.lat;
                    lng = enriched.lng;
                    if (!profile_photo_url && enriched.photo && enriched.photo.startsWith('http')) {
                        console.log("Internalizing geocoded photo during edit...");
                        const uploadRes = await OneKlicksFileSDK.uploadFileFromUrl('blood_banks', 'public', enriched.photo);
                        if (uploadRes && (uploadRes.fileid || uploadRes.fileId)) {
                            profile_photo_url = uploadRes.fileid || uploadRes.fileId;
                        } else {
                            profile_photo_url = enriched.photo;
                        }
                    }
                }
            }

            const updateData = {
                display_name: editFormData.display_name || '',
                phone: editFormData.phone || '',
                email: editFormData.email || '',
                address: editFormData.address || '',
                profile_photo_url: profile_photo_url || '',
                lat: lat || '',
                lng: lng || '',
                call_status: editFormData.call_status || '',
                call_remarks: editFormData.call_remarks || ''
            };

            const response = await oneKlicks.update('', 'blood_bank', updateData, { id: editingBloodBank.id });
            if (response.success) {
                message.success('Blood bank updated successfully');
                setEditModalVisible(false);
                getBloodBanks();
            } else {
                message.error(response.message || 'Failed to update');
            }
        } catch (error) {
            console.error('Edit save error:', error);
            message.error('Failed to update blood bank');
        } finally {
            setLoading(false);
        }
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            setUploading(true);
            const response = await OneKlicksFileSDK.uploadFile('blood_banks', 'public', file);
            if (response && (response.fileId || response.fileid)) {
                setEditFormData({ ...editFormData, profile_photo_url: response.fileId || response.fileid });
                message.success('Image uploaded successfully');
            } else {
                message.error('Upload failed');
            }
        } catch (error) {
            console.error('Upload error:', error);
            message.error('Error uploading file');
        } finally {
            setUploading(false);
        }
    };

    const handleDelete = async (record) => {
        if (window.confirm(`Are you sure you want to delete "${decodeHtml(record.display_name)}"?`)) {
            try {
                const response = await oneKlicks.delete('', 'blood_bank', { id: record.id });
                if (response && response.success) {
                    message.success('Blood Bank deleted successfully');
                    getBloodBanks();
                }
            } catch (error) {
                message.error('Failed to delete blood bank');
            }
        }
    };

    const handleStatusToggle = async (record) => {
        try {
            const newStatus = record.status == 1 ? 0 : 1;
            const response = await oneKlicks.update('', 'blood_bank', { status: newStatus }, { id: record.id });
            if (response && response.success) {
                message.success('Status updated');
                getBloodBanks();
            }
        } catch (error) {
            message.error('Failed to update status');
        }
    };

    const handleShareWhatsApp = (record) => {
        const url = `https://tech2day.co.in/blood-bank/${record.slug}`;
        const whatsappMsg = `Check out this blood bank: ${record.display_name}\nLink: ${url}`;
        sendWhatsApp(record.phone, whatsappMsg);
    };

    const openCallStatusModal = (bloodBank) => {
        setSelectedBloodBankForCallStatus(bloodBank);
        setCallStatusValue(bloodBank.call_status);
        setCallRemarks(bloodBank.call_remarks || '');
        setCallStatusModelshow(true);
    };

    const handleSaveCallStatus = async () => {
        if (!selectedBloodBankForCallStatus) return;
        try {
            const payload = {
                call_status: callStatusValue,
                call_remarks: callRemarks
            };
            const response = await oneKlicks.update('', 'blood_bank', payload, { id: selectedBloodBankForCallStatus.id });
            if (response.success) {
                message.success('Call status updated');
                setCallStatusModelshow(false);
                getBloodBanks();
            }
        } catch (error) {
            message.error('Failed to update call status');
        }
    };

    const openPackageModal = (bloodBank) => {
        setSelectedBloodBankForPackage(bloodBank);
        setShowPackageModal(true);
    };

    const fileInputRef = React.useRef(null);
    const [importing, setImporting] = useState(false);
    const [mapModalVisible, setMapModalVisible] = useState(false);

    const handleImportClick = () => {
        fileInputRef.current.click();
    };

    const handleMapImport = async (fetchedPlaces) => {
        setMapModalVisible(false);
        setImporting(true);
        let successCount = 0;
        let failCount = 0;

        try {
            for (const place of fetchedPlaces) {
                try {
                    // Check if exists
                    const possibleEmail = `${place.name.replace(/\s+/g, '').toLowerCase()}${place.place_id.substring(0, 4)}@google.import`;
                    // Since we don't have email from basic place details, we generate a placeholder or check by Name+Address?
                    // Better to check by "display_name" match if strictly unique, but different areas might have same name. 
                    // Let's rely on generated email or check by name approx.

                    // For now, let's just use a generated unique email to allow insert, and user can edit later.
                    // Or search by name to avoid duplicates.

                    // Simplified: Generate email, check if exists.
                    const conditions = { email: possibleEmail };
                    const existing = await oneKlicks.read('', 'blood_bank', conditions);

                    if (existing.success && existing.data.length > 0) {
                        // Skip or update?
                        // Let's skip for now to avoid overwriting manually managed ones unless we are sure.
                        // Or maybe update address/rating?
                        // successCount++; // Count as handled
                        continue;
                    }

                    let finalPhotoUrl = '';
                    if (place.address) {
                        const enriched = await geocodeAddress(place.address);
                        if (enriched.photo && enriched.photo.startsWith('http')) {
                            const uploadRes = await OneKlicksFileSDK.uploadFileFromUrl('blood_banks', 'public', enriched.photo);
                            if (uploadRes && (uploadRes.fileid || uploadRes.fileId)) {
                                finalPhotoUrl = uploadRes.fileid || uploadRes.fileId;
                            } else {
                                console.warn("Image internalization failed, using original URL", uploadRes);
                                finalPhotoUrl = enriched.photo;
                            }
                        }
                    }

                    const newData = {
                        display_name: place.name,
                        email: possibleEmail,
                        phone: '', // Not available in basic search
                        address: place.address,
                        lat: place.position.lat,
                        lng: place.position.lng,
                        pass: "Ravindra12@", // Default
                        status: '1',
                        user_type: 'blood_bank',
                        slug: place.name.toLowerCase().replace(/\s+/g, '-') + '-' + Math.floor(Math.random() * 1000),
                        profile_photo_url: finalPhotoUrl
                    };

                    await oneKlicks.create('', 'blood_bank', newData);
                    successCount++;

                } catch (err) {
                    console.error("Error importing place", place, err);
                    failCount++;
                }
            }
            toast.success(`Google Map Import complete. Added: ${successCount}`);
            getBloodBanks();
        } catch (e) {
            console.error(e);
            toast.error("Error during import");
        } finally {
            setImporting(false);
        }
    };

    const handleExcelFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setImporting(true);
        const reader = new FileReader();

        reader.onload = async (evt) => {
            try {
                const bstr = evt.target.result;
                const wb = read(bstr, { type: 'binary' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = utils.sheet_to_json(ws);

                if (data.length === 0) {
                    toast.error("Excel file is empty");
                    setImporting(false);
                    return;
                }

                let successCount = 0;
                let failCount = 0;

                toast.info(`Processing ${data.length} records. Fetching locations and photos...`);

                for (const row of data) {
                    try {
                        if (!row.Name && !row.name && !row.display_name) continue;

                        const displayName = row.Name || row.name || row.display_name;
                        let email = row.Email || row.email;
                        const phone = row.Phone || row.phone;
                        const address = row.Address || row.address;
                        const password = row.Password || row.password || "Ravindra12@";

                        let photoUrl = row.Image || row.PhotoUrl || row.photourl || row.profile_photo_url || row.profile_photo || row.ImageURL || row['Image URL'] || '';
                        let lat = row.Lat || row.lat;
                        let lng = row.Lng || row.lng;

                        // Geocode and fetch photo if missing
                        if (address && (!lat || !lng || !photoUrl)) {
                            await new Promise(r => setTimeout(r, 200)); // Rate limit
                            const enriched = await geocodeAddress(address);
                            if (enriched.lat) {
                                if (!lat) lat = enriched.lat;
                                if (!lng) lng = enriched.lng;
                                if (!photoUrl) photoUrl = enriched.photo;
                            }
                        }

                        if (photoUrl && typeof photoUrl === 'string') {
                            photoUrl = photoUrl.trim();
                            if (photoUrl.startsWith('http')) {
                                console.log(`Internalizing image for ${displayName}: ${photoUrl}`);
                                const uploadRes = await OneKlicksFileSDK.uploadFileFromUrl('blood_banks', 'public', photoUrl);
                                if (uploadRes && (uploadRes.fileid || uploadRes.fileId)) {
                                    photoUrl = uploadRes.fileid || uploadRes.fileId;
                                    console.log(`Success: ${photoUrl}`);
                                } else {
                                    console.warn(`Internalization failed for ${displayName}, keeping original URL`, uploadRes);
                                }
                            }
                        }

                        const commonData = {
                            display_name: displayName.trim(),
                            phone: phone ? String(phone).trim() : '',
                            address: address ? address.trim() : '',
                            profile_photo_url: photoUrl,
                            lat: lat,
                            lng: lng
                        };

                        // 1. Try exact match by Email
                        let conditions = { email: email };
                        let existing = { success: false, data: [] };
                        if (email) {
                            existing = await oneKlicks.read('', 'blood_bank', conditions);
                        }

                        // 2. Try exact match by Phone
                        if ((!existing.success || existing.data.length === 0) && phone) {
                            conditions = { phone: String(phone).trim() };
                            existing = await oneKlicks.read('', 'blood_bank', conditions);
                        }

                        // 3. Try exact match by Display Name
                        if (!existing.success || existing.data.length === 0) {
                            conditions = { display_name: displayName.trim() };
                            existing = await oneKlicks.read('', 'blood_bank', conditions);
                        }

                        // 4. Try Search by Name (Fuzzy fallback)
                        if (!existing.success || existing.data.length === 0) {
                            const searchObj = { display_name: displayName.trim() };
                            existing = await oneKlicks.read('', 'blood_bank', {}, 'id DESC', searchObj);
                        }

                        if (existing.success && existing.data.length > 0) {
                            const existingId = existing.data[0].id;
                            console.log(`Updating existing blood bank ID: ${existingId}`);
                            // Clean empty fields but allow updating photo even if currently empty but provided in Excel
                            Object.keys(commonData).forEach(key => {
                                if (commonData[key] === null || commonData[key] === undefined || commonData[key] === '') {
                                    delete commonData[key];
                                }
                            });
                            const updateRes = await oneKlicks.update('', 'blood_bank', commonData, { id: existingId });
                            if (updateRes.success) {
                                successCount++;
                            } else {
                                console.error(`Failed to update ${displayName}:`, updateRes);
                                failCount++;
                            }
                        } else {
                            console.log(`Creating new blood bank: ${displayName}`);
                            if (!email) {
                                const username = displayName.replace(/[^a-zA-Z0-9]/g, '').toLowerCase().substring(0, 15) + (Math.floor(Math.random() * 999));
                                email = `${username}@meddylist.import`;
                            }
                            const newData = {
                                ...commonData,
                                email: email,
                                pass: password,
                                status: '1',
                                user_type: 'blood_bank',
                                slug: displayName.toLowerCase().replace(/\s+/g, '-') + '-' + Math.floor(Math.random() * 1000)
                            };
                            const createRes = await oneKlicks.create('', 'blood_bank', newData);
                            if (createRes.success) {
                                successCount++;
                            } else {
                                console.error(`Failed to create ${displayName}:`, createRes);
                                failCount++;
                            }
                        }
                    } catch (err) {
                        console.error("Error importing row", row, err);
                        failCount++;
                    }
                }

                toast.success(`Import complete. Success: ${successCount}`);
                getBloodBanks();

            } catch (error) {
                console.error("Error parsing Excel", error);
                toast.error("Failed to parse Excel file");
            } finally {
                setImporting(false);
                e.target.value = null; // Reset input
            }
        };

        reader.readAsBinaryString(file);
    };

    return (
        <div className="container-fluid py-4">
            <div className="card mb-4 border-0 shadow-sm">
                <div className="card-body p-4">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <h4 className="mb-1 fw-bold">Blood Bank Management</h4>
                            <p className="text-muted mb-0">Manage and monitor blood bank service providers</p>
                        </div>
                        <div className="col-md-6 text-md-end mt-3 mt-md-0">
                            <Space size="middle">
                                <InputGroup style={{ width: '300px' }}>
                                    <Form.Control
                                        placeholder="Search by name, phone, email..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        className="shadow-none"
                                    />
                                </InputGroup>
                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => navigate("/authentication?type=blood_bank&admin_add=true")}
                                    size="large"
                                    className="d-flex align-items-center"
                                >
                                    Add New Blood Bank
                                </Button>
                                <Button
                                    icon={<UploadOutlined />}
                                    onClick={handleImportClick}
                                    loading={importing}
                                    size="large"
                                >
                                    Import Excel
                                </Button>
                                <Button
                                    icon={<CompassOutlined />}
                                    onClick={() => setMapModalVisible(true)}
                                    size="large"
                                >
                                    Fetch from Map
                                </Button>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleExcelFileChange}
                                    accept=".xlsx, .xls"
                                />

                            </Space>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card border-0 shadow-sm">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="bg-light text-muted text-uppercase" style={{ fontSize: '12px' }}>
                                <tr>
                                    <th className="px-4 py-3">Details</th>
                                    <th>Contact Info</th>
                                    <th>Call Status</th>
                                    <th>Current Package</th>
                                    <th>Status</th>
                                    <th className="text-end px-4">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5">
                                            <Progress percent={100} status="active" showInfo={false} style={{ width: '200px' }} />
                                            <div className="mt-2">Loading blood banks...</div>
                                        </td>
                                    </tr>
                                ) : data.length > 0 ? (
                                    data.map((item) => (
                                        <tr key={item.id}>
                                            <td className="px-4 py-3">
                                                <div className="d-flex align-items-center">
                                                    <ImageShow
                                                        image={item.profile_photo_url}
                                                        width={45}
                                                        height={45}
                                                        style={{ borderRadius: '8px', objectFit: 'cover' }}
                                                        className="shadow-sm bg-light"
                                                    />
                                                    <div className="ms-3">
                                                        <div className="fw-bold text-dark">{decodeHtml(item.display_name)}</div>
                                                        <small className="text-muted">ID: #{item.id}</small>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-column" style={{ fontSize: '13px' }}>
                                                    <span className="mb-1"><i className="ti-headphone-alt me-2"></i>{item.phone || 'N/A'}</span>
                                                    <span className="text-muted"><i className="ti-location-pin me-2"></i>{item.address || 'Location N/A'}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <Button
                                                    size="small"
                                                    className="rounded-pill px-3"
                                                    onClick={() => openCallStatusModal(item)}
                                                    type={item.call_status ? "default" : "dashed"}
                                                >
                                                    {item.call_status || "Set Call Status"}
                                                </Button>
                                            </td>
                                            <td>
                                                <Badge
                                                    bg="light"
                                                    text="primary"
                                                    className="border cursor-pointer p-2"
                                                    onClick={() => openPackageModal(item)}
                                                >
                                                    {item.user_package?.[0]?.package_details?.[0]?.name || "Free Plan"}
                                                </Badge>
                                            </td>
                                            <td>
                                                <Badge
                                                    bg={item.status == 1 ? "success" : "danger"}
                                                    className="cursor-pointer px-3 py-2 rounded-pill"
                                                    onClick={() => handleStatusToggle(item)}
                                                >
                                                    {item.status == 1 ? 'Active' : 'Inactive'}
                                                </Badge>
                                            </td>
                                            <td className="text-end px-4">
                                                <Space size="small">
                                                    <Tooltip title="Edit Details">
                                                        <Button
                                                            shape="circle"
                                                            icon={<EditOutlined />}
                                                            onClick={() => handleEdit(item)}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip title="Login as Blood Bank">
                                                        <Button
                                                            shape="circle"
                                                            icon={<LoginOutlined />}
                                                            onClick={() => handleLoginAs(item)}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip title="WhatsApp Share">
                                                        <Button
                                                            shape="circle"
                                                            icon={<WhatsAppOutlined />}
                                                            className="text-success border-success"
                                                            onClick={() => handleShareWhatsApp(item)}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip title="Delete">
                                                        <Button
                                                            shape="circle"
                                                            danger
                                                            icon={<DeleteOutlined />}
                                                            onClick={() => handleDelete(item)}
                                                        />
                                                    </Tooltip>
                                                </Space>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5 text-muted">
                                            No blood bank services found matching your search.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="p-4 border-top">
                        <Paginationnew currentPage={page} totalPages={totalPages} handlePageChange={(p) => setPage(p)} />
                    </div>
                </div>
            </div>

            <Modal
                title="Update Call Status"
                open={callStatusModelshow}
                onCancel={() => setCallStatusModelshow(false)}
                onOk={handleSaveCallStatus}
                centered
                destroyOnClose
            >
                <div className="mb-4 mt-3">
                    <label className="form-label fw-bold">Call Outcome</label>
                    <Select
                        className="w-100"
                        placeholder="Select status"
                        options={callStatusOptions}
                        value={callStatusValue}
                        onChange={setCallStatusValue}
                        size="large"
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label fw-bold">Follow-up Remarks</label>
                    <TextArea
                        rows={4}
                        placeholder="Enter any notes about the call..."
                        value={callRemarks}
                        onChange={(e) => setCallRemarks(e.target.value)}
                        className="rounded"
                    />
                </div>
            </Modal>

            <Modal
                title="Edit Blood Bank Details"
                open={editModalVisible}
                onCancel={() => setEditModalVisible(false)}
                onOk={handleEditSave}
                width={800}
                centered
                destroyOnClose
            >
                <div className="row g-3 p-2">
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Display Name</label>
                        <Input
                            value={editFormData.display_name}
                            onChange={(e) => setEditFormData({ ...editFormData, display_name: e.target.value })}
                            placeholder="Enter display name"
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Phone</label>
                        <Input
                            value={editFormData.phone}
                            onChange={(e) => setEditFormData({ ...editFormData, phone: e.target.value })}
                            placeholder="Enter phone number"
                        />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label fw-bold">Address</label>
                        <TextArea
                            rows={2}
                            value={editFormData.address}
                            onChange={(e) => setEditFormData({ ...editFormData, address: e.target.value })}
                            placeholder="Enter full address"
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Email</label>
                        <Input
                            value={editFormData.email}
                            onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
                            placeholder="Enter email"
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Profile Photo</label>
                        <div className="d-flex flex-column gap-2">
                            <div className="d-flex align-items-center gap-3">
                                <ImageShow image={editFormData.profile_photo_url} width={50} height={50} style={{ borderRadius: '8px' }} />
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={handleFileUpload}
                                    accept="image/*"
                                    disabled={uploading}
                                />
                            </div>
                            <div className="input-group">
                                <Input
                                    placeholder="Or paste an image URL here..."
                                    onPressEnter={async (e) => {
                                        const url = e.target.value.trim();
                                        if (url && url.startsWith('http')) {
                                            try {
                                                setUploading(true);
                                                const res = await OneKlicksFileSDK.uploadFileFromUrl('blood_banks', 'public', url);
                                                if (res && (res.fileid || res.fileId)) {
                                                    setEditFormData({ ...editFormData, profile_photo_url: res.fileid || res.fileId });
                                                    message.success('Image internalized from URL');
                                                    e.target.value = '';
                                                } else {
                                                    message.error('Failed to internalize image from URL');
                                                }
                                            } catch (err) {
                                                message.error('Error fetching image from URL');
                                            } finally {
                                                setUploading(false);
                                            }
                                        }
                                    }}
                                />
                                <Button
                                    onClick={async () => {
                                        const input = document.querySelector('input[placeholder="Or paste an image URL here..."]');
                                        const url = input.value.trim();
                                        if (url && url.startsWith('http')) {
                                            try {
                                                setUploading(true);
                                                const res = await OneKlicksFileSDK.uploadFileFromUrl('blood_banks', 'public', url);
                                                if (res && (res.fileid || res.fileId)) {
                                                    setEditFormData({ ...editFormData, profile_photo_url: res.fileid || res.fileId });
                                                    message.success('Image internalized from URL');
                                                    input.value = '';
                                                } else {
                                                    message.error('Failed to internalize image from URL');
                                                }
                                            } catch (err) {
                                                message.error('Error fetching image from URL');
                                            } finally {
                                                setUploading(false);
                                            }
                                        } else {
                                            message.warning('Please enter a valid HTTP URL');
                                        }
                                    }}
                                    loading={uploading}
                                >
                                    Upload URL
                                </Button>
                            </div>
                            {uploading && <Progress percent={100} status="active" showInfo={false} />}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Call Status</label>
                        <Select
                            className="w-100"
                            placeholder="Select status"
                            options={callStatusOptions}
                            value={editFormData.call_status}
                            onChange={(val) => setEditFormData({ ...editFormData, call_status: val })}
                        />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label fw-bold">Call Remarks</label>
                        <TextArea
                            rows={3}
                            value={editFormData.call_remarks}
                            onChange={(e) => setEditFormData({ ...editFormData, call_remarks: e.target.value })}
                            placeholder="Enter call remarks"
                        />
                    </div>
                </div>
            </Modal>

            <AddInvoiceModel
                showAdd={showPackageModal}
                setShowAdd={setShowPackageModal}
                mode="add"
                getdata={getBloodBanks}

                addbydocter={selectedBloodBankForPackage}
            />

            <FetchBloodBankMapModal
                open={mapModalVisible}
                onCancel={() => setMapModalVisible(false)}
                onImport={handleMapImport}
                apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
            />
        </div>
    );
};

export default BloodBanks;
